import {useEffect, useState} from "react";

export default function useSchedules (date) {
	const [schedule, setSchedule] = useState(null);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState([]);
	const [warnings, setWarnings] = useState([]);

	useEffect(() => {
		let isMounted = true;
		const abortController = new AbortController();

		(async () => {
			setLoading(true);
			setErrors([]);
			setWarnings([]);
			setSchedule(null);

			try {
				const urlSearchParams = new URLSearchParams();
				let dateString = `${date.getFullYear()}-${(date.getMonth() + 1).toString().length === 1 ? `0${date.getMonth() + 1}`:date.getMonth() + 1}-${(date.getDate() ).toString().length === 1 ? `0${date.getDate() }`:date.getDate() }`;
				urlSearchParams.append('date', dateString);
				const response = await fetch(process.env.REACT_APP_ENDPOINT + '/schedules?' + urlSearchParams.toString(), {
					signal: abortController.signal
				});
				if (response.status === 200) {
					const json = await response.json();
					setSchedule(json.schedule);
				}
				else if (response.status === 404) {
					setWarnings(["This schedule has not yet been calculated."]);
				}
				else {
					console.log(response.status);
					setErrors(["Wrong status code"]);
				}
			}
			catch (e) {
				console.error(e);
				if (e.name !== "AbortError") {
					setErrors(["Failed to connect to the server."]);
				}
			}
			finally {
				isMounted && setLoading(false);
			}
		})();

		return () => {
			isMounted = false;
			abortController.abort();
		}
	}, [date]);

	return {schedule, loading, errors, warnings};
};
